export default {
    _prefix: "ScorableQuestion",
    errors: {
        requiredQuestion: "This question must be answered.",
        requiredComment: "A comment is required for this question.",
        explanationResponseEmpty: "Response text must not be empty.",
    },
    labels: {
        criticalQuestion: "Critical Question",
        fatalQuestion: "Fatal Question",
        correct: "Correct",
        incorrect: "Incorrect",
        partial: "Partial",
        markedNA: "Not Applicable",
    },
};
